import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { 
  Box,
  Container,
  CssBaseline
} from '@mui/material';
import { TraxxLogo } from "components";

import { useEffect } from "react";

const FormLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/forms' || location.pathname === '/forms/') navigate('/forms/standing-instructions')
  }, [])
  
  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <Box
        sx={{
          my: '2rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0px 0px 10px lightgray',
          borderRadius: '6px',
          backgroundColor: 'rgba(255,255,255,0.9)',
          px: 7,
          py: 3
        }}
      >
        <Box sx={{ m: 3 }}><TraxxLogo size="medium" /></Box>
        <Outlet />
      </Box>
    </Container>
  )
}

export default FormLayout;